"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMix = calculateMix;
exports.setPropertiesAir1 = setPropertiesAir1;
exports.setPropertiesAir2 = setPropertiesAir2;
function calculateMix() {
    return {
        type: "air-mixing-tool/CALCULATE-MIX"
    };
}
function setPropertiesAir1(pvs) {
    return {
        type: "air-mixing-tool/SET-PROPERTIES-AIR1",
        payload: pvs
    };
}
function setPropertiesAir2(pvs) {
    return {
        type: "air-mixing-tool/SET-PROPERTIES-AIR2",
        payload: pvs
    };
}
//# sourceMappingURL=actions.js.map